module.exports = __webpack_public_path__ + "fonts/3266ea3.eot";